import { MOKA_INVENTORY_API } from 'api/constants';

export const DISCOUNTS = `${MOKA_INVENTORY_API}/v2/discounts`;
export const POST_DISCOUNT = `${MOKA_INVENTORY_API}/v1/discounts`;
export const PUT_DISCOUNT = id => `${MOKA_INVENTORY_API}/v1/discounts/${id}`;
export const DELETE_DISCOUNT = id => `${MOKA_INVENTORY_API}/v1/discounts/${id}`;
export const CREATE_ALL_OUTLET = `${MOKA_INVENTORY_API}/v1/discounts/create_all_outlet`;
